import { Component, AfterViewInit, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';

import { ApiError, BaseTypeahead, BaseTypeaheadService, MessageService } from '../../../core';
import { Pais } from '../pais';
import { PaisTypeaheadHttpService } from './pais-typeahead-http.service';

import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

@Component({
    selector: 'sgt-pais-typeahead',
    templateUrl: './pais-typeahead.component.html',
    styleUrls: ['./pais-typeahead.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TypeaheadPaisComponent), multi: true },
    ]
})
export class TypeaheadPaisComponent implements OnInit, AfterViewInit, BaseTypeahead<Pais> {
    @Input() entity: Pais;
    @Output() ngModelChange = new EventEmitter<Pais>();

    @Input() required: any;
    @Input() disabled: any;
    @Input() readonly: any;
    @Input() ngControl: NgControl;
    @Input() autofocus = false;
    @Input() dropup = false;
    @Input() typeaheadOptionsInScrollableView = 5; // Quantidade de itens visíveis no no scroll do typeahead
    @Output() typeaheadChange = new EventEmitter<Pais>();

    @ViewChild('inputTypeahead', {static: true}) inputTypeahead: ElementRef;
    typeaheadOptionsLimit = 1000; // Quantidade máxima de registros exibidos no typeahead
    typeaheadSelected: string;
    typeaheadToken: string;
    typeaheadDataSource: Observable<Pais[]>;
    typeaheadNoResults: boolean;

    currentRequest: Subscription;
    isLoading: boolean;

    propagateChange: any = () => {};

    constructor(private baseTypeaheadService: BaseTypeaheadService,
                private messageService: MessageService,
                private paisTypeaheadHttpService: PaisTypeaheadHttpService) { }

    ngOnInit() {
        this.createDataSource();
    }

    ngAfterViewInit() {
        if (this.autofocus) {
            jQuery(this.inputTypeahead.nativeElement).focus();
        }
    }

    /** Cria o data source do typeahead */
    createDataSource() {
        this.typeaheadDataSource = Observable.create((observer: any) => {
            if (this.currentRequest) {
                this.currentRequest.unsubscribe();
            }

            this.currentRequest = this.paisTypeaheadHttpService.search(this.typeaheadToken, this.typeaheadOptionsLimit)
                                        .subscribe(
                                            (entities: Pais[]) => observer.next(entities),
                                            (error: ApiError) => {
                                                this.messageService.error(error.message, 'Ocorreu um erro ao pesquisar os países. Tente novamente', error);
                                                observer.next([]);
                                            }
                                        );
        });
    }


    /** Ao digitar no input do typeahead */
    onKeyup(e: KeyboardEvent) {
        this.baseTypeaheadService.onKeyup(this, e);
    }

    /** Ao sair do input do typeahead */
    onBlur() {
        this.baseTypeaheadService.onBlur(this);
    }


    /** Verifica se o typeahead possui resultados */
    onChangeTypeaheadNoResults(noResults: boolean) {
        this.typeaheadNoResults = noResults;
    }

    /** Ao selecionar a Pais no typeahead */
    onSelectEntity(tm: TypeaheadMatch) {
        this.baseTypeaheadService.onSelectEntity(this, tm);
    }

    /** Limpa o typeahead e o model */
    clear() {
        this.baseTypeaheadService.clear(this);
    }

   /** Quando recebe um objeto Pais de "fora" do component */
    writeValue(value: Pais) {
        if (value) {
            this.baseTypeaheadService.writeValue(this, value, value.nome);
        } else {
            this.baseTypeaheadService.writeValue(this, null);
        }
    }

    /** Propaga as alterações */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
